export default __webpack_public_path__ + "static/media/by-air.75d08f45.svg";